/**
 * Khung dùng chung cho các màn ngoài shell (docs/02 §2.12 — prototype chưa có,
 * dựng theo mô tả và dùng lại design token).
 */

import type { ReactNode } from 'react';
import { Icon } from '../../components/Icon';
import { useT } from '../../lib/i18n';

export function AuthLayout({
  title,
  lede,
  children,
  foot,
}: {
  title: string;
  lede?: string;
  children: ReactNode;
  foot?: ReactNode;
}) {
  const t = useT();
  return (
    <div className="auth-wrap">
      <main className="auth-card" data-od-id="auth-card">
        <div className="auth-brand">
          <span className="brand-mark">
            <Icon name="domains" size={19} />
          </span>
          <span>
            <span className="brand-name">{t('app.name')}</span>
            <br />
            <span className="brand-sub">{t('app.tagline')}</span>
          </span>
        </div>

        <h1>{title}</h1>
        {lede ? <p className="lede">{lede}</p> : null}

        {children}

        {foot ? <div className="auth-foot">{foot}</div> : null}
      </main>
    </div>
  );
}

export function FormAlert({
  tone = 'bad',
  children,
}: {
  tone?: 'bad' | 'ok' | 'warn';
  children: ReactNode;
}) {
  return (
    <div className={`form-alert ${tone}`} role={tone === 'bad' ? 'alert' : 'status'}>
      <Icon name={tone === 'ok' ? 'check' : tone === 'warn' ? 'info' : 'warn'} size={16} />
      <span>{children}</span>
    </div>
  );
}
